// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getFulfillmentFiles } from '@/fulfillment/api/get-fulfillment-files';
import { fulfillmentFilesQueryKey } from '@/fulfillment/query-keys';
import { useQuery } from '@tanstack/react-query';

interface UseFulfillmentFilesOptions {
  /** The key of the fulfillment order to fetch files for */
  fulfillmentKey: string;
}

/**
 * Hook to fetch files associated with a fulfillment order.
 * Uses a regular query (not suspense) to allow graceful error handling
 * without crashing the entire page.
 *
 * @param options - Options including the fulfillment key
 * @returns The files, loading state, error state, and query methods
 */
export function useFulfillmentFiles(options: UseFulfillmentFilesOptions) {
  const { data, isLoading, isError, error, refetch, ...query } = useQuery({
    queryKey: fulfillmentFilesQueryKey(options.fulfillmentKey),
    queryFn: () => getFulfillmentFiles(options.fulfillmentKey),
  });

  return {
    files: data?.data ?? [],
    isLoading,
    isError,
    error,
    refetch,
    ...query,
  };
}
